import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { ControlIcons } from 'owa-control-icons';
import { AssetIcon } from 'owa-timestream-asset-sdk';
import type { TipsInfo } from '../schema';
import TipsCard from './TipsCard';
import loc from 'owa-localize';
import { tipsName } from '../tipStrings.locstring.json';
import getTipsInfo from '../utils/getTipsInfo';
import { Carousel, CarouselCardContent } from 'owa-carousel';

export default observer(function TipsView() {
    return (
        <div className={styles.tipsView}>
            <div className={styles.tipsViewHeader}>
                <div className={styles.tipsViewHeaderContent}>
                    <AssetIcon iconName={ControlIcons.Lightbulb} className={styles.tbd} />
                    <span className={styles.tipsTitle}>{loc(tipsName)}</span>
                </div>
            </div>
            <Carousel
                cardContent={getTipsContent()}
                infiniteLoop={true}
                useNumericPagination={true}
                paginationClassName={styles.carouselPagination}
            />
        </div>
    );
});

function getTipsContent(): CarouselCardContent[] {
    const tipsInfo: TipsInfo[] = getTipsInfo();

    const tipsContent: CarouselCardContent[] = tipsInfo.map(tip => {
        return {
            content: () => <TipsCard tipsInfo={tip} />,
            ariaLabel: loc(tip.instructionsResourceId),
        };
    });

    return tipsContent;
}
